const STATUS_MAP = {
  new:         { label: 'New',         cls: 'badge--new'      },
  open:        { label: 'Open',        cls: 'badge--open'     },
  in_progress: { label: 'In progress', cls: 'badge--progress' },
  resolved:    { label: 'Resolved',    cls: 'badge--resolved' },
}

export default function StatusBadge({ status, labelOverride }) {
  const config = STATUS_MAP[status] ?? { label: status, cls: '' }
  return (
    <span className={`status-badge ${config.cls}`}>
      {labelOverride ?? config.label}
    </span>
  )
}
